import { Button } from '@mui/material';
import classNames from 'classnames';

import styles from './style.module.less';

export default function JackpotHelp(modal) {
  return (
    <div
      style={{
        padding: '0.4rem 0.3rem 0.3rem',
        fontSize: '0.32rem',
        lineHeight: '0.6rem'
      }}
    >
      VIP members only. Join the JACKPOT lottery by betting on selected games and withdraw your bonuses directly to your
      account. Featured games include: Lucky Fruit, Halloween, Crazy777, Gates of Olympus, Fortune Rabbit, Fortune
      Tiger, Joker&apos;s Jewels, Cash Ultimate, Champions of Rome, Treasure, and Fortune Dragon.
      <div style={{ display: 'flex' }}>
        <Button
          className={classNames(styles.btn, 'global_button_succes')}
          sx={{
            width: '2.8rem',
            fontSize: '0.32rem',
            height: '0.8rem',
            borderRadius: '0.4rem',
            textTransform: 'none',
            margin: '0.6rem auto auto'
          }}
          variant="text"
          onClick={() => {
            modal?.hide();
          }}
        >
          Ok
        </Button>
      </div>
    </div>
  );
}
